import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import Button from '../../../../../components/Button/Button'
import { useDispatch, useSelector } from 'react-redux'
import { SELLER_EDITPROFILE, SELLER_VIEWPROFILE } from '../../../../../Redux-Toolkit/Actions/sagaActions'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import Loader from '../../../../../components/Loader/Loader'
import { ReactComponent as SelectImg } from '../../../../../assets/images/selectimg.svg'
import { useRef } from 'react'
import { useState } from 'react'
import { max } from 'moment'
function ProfileSettings() {
    const dispatch = useDispatch()
    const { data, isloading } = useSelector((action) => action.settingsSlice)
    const validationSchema = yup.object({
        fullName: yup.string().max(30,"Fullname should be 30 characters long.").required('Please Enter Full Name.'),
        storeName: yup.string().max(30,"Fullname should be 30 characters long.").required('Please Enter Store Name.'),
        email: yup.string().required('Please Enter Email Address'),
        // .max(
        //     30,
        //     'Username or Email must be between 8 to 30 characters long'
        // ),
        phoneNo: yup.string().required('Please Enter Phone Number').min(10,"Only 10 digits mobile number should be valid.").max(10,"Only 10 digits mobile number should be valid"),
    })
    const {
        reset,
        register,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm({ resolver: yupResolver(validationSchema), mode: 'all' })

    useEffect(() => {
        console.log(data?.profilePic,"profilePic");
        if (data) {
            reset(data)
            setImageUrl(data?.profilePic)
        }
    }, [data])

    const uploadImage = useRef(null)
    const [imageUrl, setImageUrl] = useState(null)
    const [imageErr, setimageErr] = useState('')
    const handleFileUpload = (e) => {
        if (
            e.target.files[0].type === 'image/jpg' ||
            e.target.files[0].type === 'image/jpeg' ||
            e.target.files[0].type === 'image/png'
        ) {
            setValue('profilePic', e.target.files[0])
            setImageUrl(URL.createObjectURL(e.target.files[0]))
            setimageErr('')
        } else {
            setimageErr('Please select .jpeg, .jpg or .png file formate.')
        }
    }


    const onSubmit = (data) => {
        const formData = new FormData();
        formData.append("profilePic",data?.profilePic)
        formData.append("fullName",data?.fullName)
        formData.append("storeName",data?.storeName)
        formData.append("email",data?.email)
        formData.append("phoneNo",data?.phoneNo)
        dispatch({type:SELLER_EDITPROFILE,payload:formData})
        // dispatch({ type: SELLER_EDITPROFILE, payload: { fullName: data.fullName, storeName: data.storeName, email: data.email, phoneNo: data.phoneNo } })
        // reset()   
    }

    return (

        <div className="admin-card setting-content">
            <div className="head">
                <h2>Profile Settings</h2>
            </div>
            {isloading && <Loader />}
            <div className="support-body-content">
                <form action="" className="profile-setting-form" onSubmit={handleSubmit(onSubmit)}> 
                    <Row>
                    <Col lg="12">
                            <div className='form-group'>
                                <div className="profile-image mb-0">
                                    <img src={imageUrl} alt='' />
                                    <div
                                        className="selectimg"
                                        onClick={() => uploadImage.current.click()}
                                    >
                                        <input
                                            type="file"
                                            ref={(event) => {
                                                register('profilePic')
                                                uploadImage.current = event
                                            }}
                                            accept=".jpg,.png,.jpeg"
                                            style={{ display: 'none' }}
                                            onChange={handleFileUpload}
                                        />
                                        <SelectImg />
                                    </div>
                                </div>
                                {!!imageErr && <span style={{ color: 'red' }}>{imageErr}</span>}
                            </div>
                        </Col>
                        {/* <Col xxl="4" lg="6" md="6">
                            <div className="form-group">
                                <label>First Name</label>
                                <input type="text" name="fullName" {...register("fullName")} />
                            <span style={{ color: 'red' }}>
                  {errors.fullName?.message}
                </span>
                            </div>
                        </Col>
                        <Col xxl="4" lg="6" md="6">
                            <div className="form-group">
                                <label>Last Name</label>
                                <input type="text" name="lname" {...register("lname")} />
                            <span style={{ color: 'red' }}>
                  {errors.lname?.message}
                </span>
                            </div>
                        </Col> */}
                        <Col xxl="4" lg="6" md="6">
                            <div className="form-group">
                                <label>Full Name</label>
                                <input type="text" name="fullName" {...register("fullName")} autoComplete="off"/>
                                <span style={{ color: 'red' }}>
                                    {errors.fullName?.message}
                                </span>
                            </div>
                        </Col>
                        <Col xxl="4" lg="6" md="6">
                            <div className="form-group">
                                <label>Store Name</label>
                                <input type="text" name="storeName" {...register("storeName")} />
                                <span style={{ color: 'red' }}>
                                    {errors.storeName?.message}
                                </span>
                            </div>
                        </Col>
                        <Col xxl="4" lg="6" md="6">
                            <div className="form-group">
                                <label>Email Address</label>
                                <input
                                    type="text"
                                    name="email"
                                    {...register("email")}
                                />
                                <span style={{ color: 'red' }}>
                                    {errors.email?.message}
                                </span>
                            </div>
                        </Col>
                        <Col xxl="4" lg="6" md="6">
                            <div className="form-group">
                                <label>Phone No</label>
                                {/* <input type="number" name="phoneNo" {...register("phoneNo")} /> */}
                                <input
                                    type="text" 
                                    {...register("phoneNo")}
                                    autoComplete="off"
                                    onKeyDown={(e) => {
                                        if (
                                            ![
                                                'ArrowLeft',
                                                'ArrowRight',
                                                'Delete',
                                                'Backspace',
                                                ...Array.from(
                                                    { length: 10 },
                                                    (_, i) =>
                                                        i.toString()
                                                )
                                            ].includes(e.key)
                                        ) {
                                            e.preventDefault()
                                        }
                                    }}
                                />
                                <span style={{ color: 'red' }}>
                                    {errors.phoneNo?.message}
                                </span>
                            </div>
                        </Col>
                        <Col lg="12">
                            <Button commonClass="solid-red-btn" text={'Edit'} />
                        </Col>
                    </Row>
                </form>
            </div>
        </div>
    )
}

export default ProfileSettings
